
const state = {
    bank: [],
    id: [],
    loading: false
};

export default state;